var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 578 308.2",
    style: {
      enableBackground: "new 0 0 578 308.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E1ECFF;}\n\t.st1{fill:#FF97C9;}\n\t.st2{fill:#1C3177;}\n\t.st3{fill:#F774B9;}\n\t.st4{fill:none;stroke:#99ADF9;stroke-width:18;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st5{fill:#FEC272;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.4,278.6c-26-27.5,1.8-101,43.8-145.9c51-54.7,121.4-100.6,257.4-85c112.3,12.9,182,69.5,205.7,98.7 c37.7,46.4,64.9,111.8,42.2,138.8c-38.1,45.4-195.6-31.9-281-33.4C198.1,250.2,73.4,339.8,15.4,278.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M418.9,234.7H122.5L60.1,30.9c-0.6-1.9-0.7-4-0.4-6c0.3-2,1.2-3.9,2.4-5.5c1.2-1.6,2.8-3,4.6-3.9 c1.8-0.9,3.8-1.4,5.9-1.4h269.2c2.8,0,5.5,0.9,7.7,2.6c2.2,1.7,3.9,4,4.7,6.7L418.9,234.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M370.3,210.4H157.7c-2.8,0-5.5-0.9-7.8-2.6c-2.3-1.7-3.9-4-4.7-6.7L97.9,46.8c-0.3-1-0.4-2-0.2-3 c0.2-1,0.6-2,1.2-2.8c0.6-0.8,1.4-1.5,2.3-2c0.9-0.5,1.9-0.7,2.9-0.7h212.6c2.8,0,5.5,0.9,7.8,2.6c2.3,1.7,3.9,4,4.8,6.7l47.2,154.3 c0.3,1,0.4,2,0.2,3c-0.2,1-0.6,2-1.2,2.8c-0.6,0.8-1.4,1.5-2.3,2C372.4,210.2,371.3,210.4,370.3,210.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M122.5,234.7h398.1c2.7,0,5.3,1.1,7.2,3c1.9,1.9,3,4.5,3,7.2v13.5c0,2.7-1.1,5.3-3,7.2c-1.9,1.9-4.5,3-7.2,3 h-388c-1.3,0-2.6-0.3-3.9-0.8c-1.2-0.5-2.3-1.3-3.3-2.2c-0.9-0.9-1.7-2.1-2.2-3.3c-0.5-1.2-0.8-2.5-0.8-3.9V234.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M171,131.8l24.2-27"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M200.9,131.8l-36.5-27"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M290.6,131.8l24.2-27"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M320.5,131.8l-36.5-27"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M230.7,148.9c0,0,19-10.5,38.3,0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M438,117c-2.2,0-4.3-0.8-6-2.1c-1.7-1.4-2.9-3.3-3.4-5.4c-1.8-8-2.9-14.2-1.3-19.9c1.9-6.8,6.9-10.8,12.2-14.6 c3.6-2.6,6.1-6.5,6.4-9.9c0.2-2.3-0.6-4.2-2.5-6.1c-5.6-5.5-14.8,3-15.2,3.4c0,0-7.7,6.5-13.4-0.3c-5.7-6.8,0-13.5,0-13.5 c3.7-3.4,7.9-6.2,12.5-8.2c11-4.7,21.4-2.9,29.4,4.8c6,5.8,8.9,13.4,8.3,21.4c-0.7,9.2-6.1,18.2-14.5,24.2c-3.9,2.8-4.7,3.8-4.8,4.1 c-0.4,1.4,1,8.1,1.6,10.6c0.3,1.4,0.3,2.9,0,4.3c-0.3,1.4-1,2.7-1.9,3.8c-0.9,1.1-2,2-3.3,2.7C440.9,116.6,439.4,117,438,117z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M442.6,150.4c6.2,0,11.2-5,11.2-11.2s-5-11.2-11.2-11.2c-6.2,0-11.2,5-11.2,11.2S436.5,150.4,442.6,150.4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.e3616c4ecc03f22653d0cbcdc5de4f7f.svg";
export { ForwardRef as ReactComponent };